// extracted by mini-css-extract-plugin
module.exports = {"carCard":"_3FL65","shimmerImg":"_2kmxv","shimmer":"_2pHXa"};